import { instance } from './index';

const authAPI = {
  signOut() {
    return instance.post('/api/auth/sign-out');
  },
};

export default authAPI;
